import { createLink } from "@tanstack/react-router";
import { forwardRef, type AnchorHTMLAttributes, type MouseEvent as ReactMouseEvent } from "react";

type MouseDownLinkProps = AnchorHTMLAttributes<HTMLAnchorElement>;

const MouseDownLinkComponent = forwardRef<HTMLAnchorElement, MouseDownLinkProps>(
  ({ onClick, onMouseDown, ...props }, ref) => {
    const handleMouseDown = (event: ReactMouseEvent<HTMLAnchorElement>) => {
      onMouseDown?.(event);
      if (event.defaultPrevented) {
        return;
      }

      onClick?.(event);

      if (event.defaultPrevented && typeof window !== "undefined") {
        window.addEventListener(
          "click",
          (clickEvent) => {
            clickEvent.preventDefault();
            clickEvent.stopPropagation();
            clickEvent.stopImmediatePropagation();
          },
          { capture: true, once: true },
        );
      }
    };

    return <a ref={ref} {...props} onMouseDown={handleMouseDown} onClick={onClick} />;
  },
);

MouseDownLinkComponent.displayName = "MouseDownLinkComponent";

export const Link = createLink(MouseDownLinkComponent);
